import * as React from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import FormControl from '@mui/joy/FormControl';
import Textarea from '@mui/joy/Textarea';
import { IconButton, Stack } from '@mui/joy';

import FormatBoldRoundedIcon from '@mui/icons-material/FormatBoldRounded';
import FormatItalicRoundedIcon from '@mui/icons-material/FormatItalicRounded';
import StrikethroughSRoundedIcon from '@mui/icons-material/StrikethroughSRounded';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import OperatorToggle from './OperatorToggle';

export default function MessageInput(props) {
  const [textAreaValue, setTextAreaValue] = React.useState('');
  const { sendCustomMessage, getUserMessages, selectedChatId, tenant_id, sucursal_id, agent_name, conversation_id, scrollToBottom, conversation, updateConversation, getConversation } = props;
  const textAreaRef = React.useRef(null);
  
  const isHumanOperator = conversation?.status === 'hablando_con_operador';

  const handleClick = () => {
    if (textAreaValue.trim() !== '') {
      if (!isHumanOperator) {
        updateConversation({
          user_id: selectedChatId,
          status: 'hablando_con_operador',
          tenant_id: tenant_id,
          sucursal_id: sucursal_id,
        }).then(() => {
          return getConversation(selectedChatId, tenant_id, sucursal_id);
        }).then(() => {
          return sendCustomMessage({
            user_id: selectedChatId,
            sucursal_id: sucursal_id,
            message: textAreaValue,
            agent_name: agent_name,
          });
        }).then(() => {
          return getUserMessages(selectedChatId, tenant_id, sucursal_id, conversation_id);
        }).then(() => {
          setTimeout(scrollToBottom, 100);
        });
      } else {
        sendCustomMessage({
          user_id: selectedChatId,
          sucursal_id: sucursal_id,
          message: textAreaValue,
          agent_name: agent_name,
        }).then(() => {
          return getUserMessages(selectedChatId, tenant_id, sucursal_id, conversation_id);
        }).then(() => {
          setTimeout(scrollToBottom, 100);
        });
      }
      setTextAreaValue('');
    }
  };
  return (
    <Box sx={{ px: 2, pb: 3 }}>
      <FormControl>
        <Textarea
          placeholder="Escribe un mensaje aquí..."
          aria-label="Message"
          ref={textAreaRef}
          onChange={(event) => setTextAreaValue(event.target.value)}
          value={textAreaValue}
          minRows={3}
          maxRows={10}
          endDecorator={
            <Stack
              direction="row"
              sx={{
                justifyContent: 'space-between',
                alignItems: 'center',
                flexGrow: 1,
                py: 1,
                pr: 1,
                borderTop: '1px solid',
                borderColor: 'divider',
              }}
            >
              {/*              <div>
                <IconButton size="sm" variant="plain" color="neutral" disabled>
                  <FormatBoldRoundedIcon />
                </IconButton>
                <IconButton size="sm" variant="plain" color="neutral" disabled>
                  <FormatItalicRoundedIcon />
                </IconButton>
                <IconButton size="sm" variant="plain" color="neutral" disabled>
                  <StrikethroughSRoundedIcon />
                </IconButton>
                <IconButton size="sm" variant="plain" color="neutral" disabled>
                  <FormatListBulletedRoundedIcon />
                </IconButton>
              </div>
              */}
              <Stack direction="row" spacing={2} alignItems="center" sx={{ justifyContent: 'space-between', width: '100%', px: 1 }}>
                <OperatorToggle 
                  isHumanOperator={isHumanOperator}
                  selectedChatId={selectedChatId}
                  tenant_id={tenant_id}
                  sucursal_id={sucursal_id}
                  agent_name={agent_name}
                  sendCustomMessage={sendCustomMessage}
                  getConversation={getConversation}
                  updateConversation={updateConversation}
                />
                <Button
                  size="sm"
                  color="primary"
                  sx={{ alignSelf: 'center', borderRadius: 'sm' }}
                  endDecorator={<SendRoundedIcon />}
                  onClick={handleClick}
                >
                  Enviar
                </Button>
              </Stack>
            </Stack>
          }
          onKeyDown={(event) => {
            if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
              handleClick();
            }
          }}
          sx={{
            '& textarea:first-of-type': {
              minHeight: 72,
            },
          }}
        />
      </FormControl>
    </Box>
  );
}